export default {
  'component.globalHeader.search': 'Buscar',
  'component.globalHeader.search.example1': 'Ejemplo de búsqueda 1',
  'component.globalHeader.search.example2': 'Ejemplo de búsqueda 2',
  'component.globalHeader.search.example3': 'Ejemplo de búsqueda 3',
  'component.globalHeader.help': 'Ayuda',
  'component.globalHeader.notification': 'Notificación',
  'component.globalHeader.notification.empty':'Has visto todas las notificaciones.',
  'component.globalHeader.message': 'Mensaje',
  'component.globalHeader.message.empty': 'Has visto todos los mensajes.',
  'component.globalHeader.event': 'Evento',
  'component.globalHeader.event.empty': 'Has visto todos los eventos.',
  'component.noticeIcon.clear': 'Borrar',
  'component.noticeIcon.cleared': 'Borrado',
  'component.noticeIcon.empty': 'Sin notificaciones',
  'component.noticeIcon.view-more': 'Ver más',
};
